const ActiveFilter = (state=null, action) => {
    switch (action.type){
        case 'SET_ACTIVE_FILTER' :
            return action.payload;
    }
    return state;
}

export default ActiveFilter;


// WEBPACK FOOTER //
// ./src/reducers/ActiveFilter.js